"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
var _FormulaEditor = _interopRequireDefault(require("../FormulaEditor"));
var _useReportSubjectEditor = require("./useReportSubjectEditor");
var _default = exports.default = {
  name: 'SubjectEditCustom',
  // 智能报表-添加科目-添加或编辑弹框-自定义添加
  components: {
    FormulaEditor: _FormulaEditor.default
  },
  inject: ['dimension', 'dataSource', 'showSelectFormulaEntry'],
  props: {
    operate: {
      type: String,
      default: 'add'
    },
    record: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      layout: {
        labelCol: {
          span: 2
        },
        wrapperCol: {
          span: 22
        }
      },
      form: {
        pid: _useReportSubjectEditor.ROOT_ID,
        id: new Date().getTime().toString(),
        type: 'classification',
        // 类型，classification（科目分类）、formula（自定义公式）
        statType: 'summary',
        // 统计方式，summary（汇总，即数据来自直属下级汇总）、formula（自定义公式）
        name: '',
        formulaRules: [],
        formulaName: '',
        formulaCode: '',
        percent: 0 // 是否显示为百分比（该参数仅在type=formula或statType=formula时生效，0-否，1-是）。显示为百分比时，将会把计算公式得到的结果乘以100之后进行显示。如公式得到的结果为“0.25”，则最终显示为“25%”。
      }
    };
  },
  watch: {
    record: {
      handler(val, oldVal) {
        if (val && !oldVal) {
          const record = _.cloneDeep(val);
          const {
            operate
          } = this;
          if (operate === 'add-child') {
            this.form.pid = record.id;
          } else if (operate === 'edit') {
            this.form = Object.assign(this.form, record);
          }
        }
      },
      immediate: true,
      deep: true
    },
    'form.type': {
      handler(val) {
        if (this.operate !== 'edit') {
          if (val === 'classification') this.form.statType = 'summary';
          if (val === 'costItem') this.form.statType = 'api'; // 费用项只能调用API进行获取
          if (val === 'formula') {
            this.form.statType = 'formula';
            this.form.formulaRules = [];
            this.form.formulaName = '';
            this.form.formulaCode = '';
            this.clearFormulaEditor();
          }
        }
      },
      immediate: true
    },
    'form.statType': {
      handler(val) {
        if (val === 'summary') {
          this.form.percent = 0;
          this.form.formulaRules = [];
          this.form.formulaName = '';
          this.form.formulaCode = '';
          this.clearFormulaEditor();
        }
      },
      immediate: true
    },
    form: {
      handler(val) {
        this.clearValidate();
        this.$emit('change', val);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    clearValidate() {
      this.$refs.form && this.$refs.form.clearValidate();
    },
    clearFormulaEditor() {
      this.$refs.formulaEditor && this.$refs.formulaEditor.clear();
    },
    handleFormulaEditorChange(res) {
      this.form = Object.assign(this.form, res);
    },
    // 触发表单校验-父组件通过 this.$refs.subjectEditCustom.validate() 方式调用
    async validate() {
      try {
        await (this.$refs.form && this.$refs.form.validate());
        return true;
      } catch (error) {
        _antDesignVue.message.warning('请完善必填项');
        return false;
      }
    }
  }
};